import React, { useMemo } from 'react';
import { SendoutEmailsTabContent } from 'features/sendouts/components/drawers/SendoutDetailsDrawer/SendoutDetailsTabs/SendoutEmailsTabContent';
import strings from 'strings';

import { DetailsTabs } from '../../../shared';
import { SendoutActivityLogsTabContent } from '../../SendoutDetailsDrawer/SendoutDetailsTabs/SendoutActivityLogsTabContent';

import { SendoverAttachmentsTabContent } from './SendoverAttachmentsTabContent';

const buildTabs = ({ sendoverId }) => [
  {
    id: 'Attachments',
    label: strings.sendoutsV2.drawers.tabs.attachments.title,
    view: <SendoverAttachmentsTabContent sendoverId={sendoverId} />
  },
  {
    id: 'Emails',
    label: strings.sendoutsV2.drawers.tabs.emails.title,
    view: <SendoutEmailsTabContent sendoutId={sendoverId} />
  },
  {
    id: 'ActivityLogs',
    label: strings.sendoutsV2.drawers.tabs.activityLogs.title,
    view: <SendoutActivityLogsTabContent sendoutId={sendoverId} />
  }
];

export const SendoverDetailsTabs = ({ sendoverId }) => {
  const tabs = useMemo(() => buildTabs({ sendoverId }), [sendoverId]);

  return <DetailsTabs initialTab={tabs[0].id} tabs={tabs} />;
};
